export default "__VITE_ASSET__dcb19b32__"